import {hrms, hrmsWithPath} from '../../services/http/api/rest';

const rest = hrmsWithPath('/v1/holiday');

const holiday = {
    list: (year?: number) => rest.get('/search', {}, {year}),
    create: (data: any) => rest.post('', {}, data),
    get: (id: string) => rest.get('/{{id}}', {id}, {}),
    delete: (id: string) => rest.del('/{{id}}', {id}),
    update: (id: any, data: object) => rest.put('/{{id}}', {id}, data),
}

export default holiday;